export default __webpack_public_path__ + "static/media/slav_l.d0216500.jpg";